import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

export default function TabPanel({ children, value, index, sx }) {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`tab-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      <Box sx={sx}>{children}</Box>
    </div>
  );
}

TabPanel.defaultProps = {
  sx: {
    p: 3,
  },
};

TabPanel.propTypes = {
  // eslint-disable-next-line react/require-default-props
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  sx: PropTypes.shape({
    p: PropTypes.number,
  }),
};
